var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlightSegment = function SvgHighlightSegment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13,
    cy: 2.13,
    r: 2.13,
    fill: "#1E242F",
    transform: "matrix(-1 0 0 1 19.742 13.24)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13,
    cy: 2.13,
    r: 2.13,
    fill: "#1E242F",
    transform: "matrix(-1 0 0 1 7.723 13.24)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M1.068 9.326c.002.183-.051.91-.123 1.547a15 15 0 0 1-.124.835c-.063.372-.126.749-.164 1.243-.065.844 0 .902.637 1.476l.012.011c.286.257.88.496 1.457.682a2.84 2.84 0 0 1 5.663.45l6.36.09a2.84 2.84 0 1 1 5.642.078l1.277.016c.76-.044 1.336-.242 1.336-.242s.122-.178.184-.312c.298-.64.038-2.134-.184-2.602-.223-.468-.575-.981-1.627-1.618-1.053-.636-3.339-1.265-3.339-1.265s-1.678-1.779-4.591-2.753-6.435-.162-7.627.208-3.575 1.343-3.905 1.522l-.12.064c-.33.176-.766.408-.764.57",
    clipRule: "evenodd"
  })));
};
export default SvgHighlightSegment;